<script lang="typescript">
  import Headline2 from "shared/typography/headline2.svelte";
  import Headline6 from "shared/typography/headline6.svelte";

  export let title = "Title";
  export let subtitle = "Subtitle and descriptions";
  /// oi
</script>

<section class="header">
  <Headline2 text={title} />
  <Headline6 text={subtitle} />
</section>

<style>
  .header {
    
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid var(--color-level-3);
    padding-bottom: 8px;
  }
</style>
